import { Box, Typography } from "@mui/material"
import { format } from "date-fns"
import { Constants } from "../../../../../../../../utils/constants"
import { useDateStyles } from "./dateStyles"

const DateItems = (props: any) => {
  const styles = useDateStyles()

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.textItem}>
        {props?.current.requestDate
          ? format(new Date(props?.current.requestDate), Constants.dateFormatGeneral2)
          : 'N/A'}
      </Typography>

      <Typography sx={styles.textItem}>
        {props?.current.solveDate
          ? format(new Date(props?.current.solveDate), Constants.dateFormatGeneral2)
          : 'N/A'}
      </Typography>
    </Box>


  )
}

export { DateItems }
